/**
 * @fileoverview Barrel export for style guide schemas.
 */

// Barrel export for clean imports
export * from './styleguide';